import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const ComfirmationPopup = ({ getPopUpMessage }) => {
  const submit = () => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: sendComfirmMessage,
        },
        {
          label: "No",
          onClick: () => alert("Click No"),
        },
      ],
    });
  };
  const sendComfirmMessage = () => {
    getPopUpMessage();
  };

  return (
    <div className="container">
      <a className="handle__updates__button" onClick={submit}>
        Edit
      </a>
      {/* <button >Confirm dialog</button> */}
    </div>
  );
};
export default ComfirmationPopup;
